import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import Button from './button';
import InfoBlock from './infoBlock';
import FairnessInput from './fairnessInput';
import AboutHashButton from './aboutHashButton';
import { popupStore } from '../../store/popupStore';
import { PopupTypes } from '../../core/constants/popupTypes';
import { ContentTypes } from '../../core/constants/contentTypes';
import DefaultRoutes from '../../routing/defaultRoutes/DefaultRoutes';
import { checkHashStore } from '../../store/checkHashStore';
import { copyToClipboard } from '../../core/helpers/copyToClipboard';
import { applicationStore } from '../../store/applicationStore';
import useTranslation from '../../hooks/useTranslation';
import { TranslationKeys } from '../../core/constants/translationKeys';
import useSelfRemoveArray from '../../core/helpers/useSelfRemoveArray';
import './fairness.scss';

const Fairness = observer(() => {
  const { isCardsGame } = applicationStore;
  const { open } = popupStore;
  const { nextRoundHash, lastRoundInfo, spinInfo, isFromBetHistory, nextHashTextInfo } =
    checkHashStore;
  const [copiedInputType, addCopyInputType] = useSelfRemoveArray();

  const t = useTranslation();

  const { salt, key, hash } = useMemo(() => {
    if (spinInfo.key || spinInfo.salt || spinInfo.hash) {
      return spinInfo;
    }
    return lastRoundInfo;
  }, [spinInfo, lastRoundInfo]);

  const openCalculator = useCallback(
    () => open({ name: PopupTypes.Calculator, lastPopupName: PopupTypes.Fairness }),
    [open]
  );

  const handleCopy = (value, type, isHashCode) => {
    if (!isHashCode) {
      checkHashStore.setCalculateSaltAndKey({ [type]: value });
    }
    if (value) {
      copyToClipboard(value);
      addCopyInputType(type);
    }
  };

  const handleToggleAboutHash = useCallback(() => {
    popupStore.open({ name: PopupTypes.AboutHash, lastPopupName: PopupTypes.Fairness });
  }, []);

  return (
    <div className='cpt-pp-content'>
      <DefaultRoutes contentType={ContentTypes.FairnessResultContent} />
      <div className='cpt-input-wrapper'>
        <div className='input-head-wrapper'>
          <FairnessInput
            t={t}
            text={TranslationKeys.Key}
            value={key}
            type='key'
            isShowCopyIcon
            handleClick={handleCopy}
            copiedInputType={copiedInputType}
          />
          <FairnessInput
            t={t}
            text={TranslationKeys.Salt}
            value={salt}
            type='salt'
            isShowCopyIcon
            handleClick={handleCopy}
            copiedInputType={copiedInputType}
          />
        </div>
        <FairnessInput
          t={t}
          text={TranslationKeys.HashCode}
          value={hash}
          type='hash'
          isShowCopyIcon
          isHashCode
          handleClick={handleCopy}
          c
          copiedInputType={copiedInputType}
        />
        <Button text={TranslationKeys.Calculate} handleClick={openCalculator} t={t} />
        {!isFromBetHistory && (
          <>
            <div className='liner-row' />
            <InfoBlock text={t(nextHashTextInfo)} isCardsGame={isCardsGame} />
            <FairnessInput
              t={t}
              isHashCode
              type='next-hash'
              text={TranslationKeys.HashCode}
              value={nextRoundHash}
              isShowCopyIcon
              handleClick={handleCopy}
              copiedInputType={copiedInputType}
            />
          </>
        )}
      </div>
      <AboutHashButton handleClick={handleToggleAboutHash} t={t} />
    </div>
  );
});
export default Fairness;
